<tr>
  <td>{{ formatAncillaryCodeName(ancillaryItemName) }}</td>
  <td>
    {{ calculatorService.convertToLocaleUsPriceString(totalPrices[0], 2) }}
    <span *ngIf="!!priceQuantities[0]" class="per-thousand">
      ({{
        calculatorService.convertToLocaleUsPriceString(priceQuantities[0], 2)
      }}/M)
    </span>
  </td>
  <td *ngIf="calculationTableConfig.showSecondCol">
    {{ calculatorService.convertToLocaleUsPriceString(totalPrices[1], 2) }}
    <span *ngIf="!!priceQuantities[1]" class="per-thousand">
      ({{
        calculatorService.convertToLocaleUsPriceString(priceQuantities[1], 2)
      }}/M)
    </span>
  </td>
  <td *ngIf="calculationTableConfig.showThirdCol">
    {{ calculatorService.convertToLocaleUsPriceString(totalPrices[2], 2) }}
    <span *ngIf="!!priceQuantities[2]" class="per-thousand">
      ({{
        calculatorService.convertToLocaleUsPriceString(priceQuantities[2], 2)
      }}/M)
    </span>
  </td>
</tr>
